import CurrentTicket from './CurrentTicket';

export default CurrentTicket;